// core/data/adminSeed.ts — typed port of cfg/admin.json
// This is the initial admin account that is seeded idempotently on first boot.
// Plaintext password is an accepted prototype constraint.

import type { Account } from '@/core/models';

export const adminSeed: Account = {
  userId:      'wayne-tech',
  username:    'admin123',
  email:       null,
  displayName: 'WayneTech',
  handle:      '@WayneTech',
  password:    '1234abcd',
  joinedAt:    '2024-01-01T00:00:00.000Z',
  useThisAsActive: false,
};
